import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { TextField } from "@mui/material";
import { API } from "../../backend";
import { toast } from "react-toastify";

const useStyles = makeStyles({
  input: {
    width: "100%",
    margin: "10px 0",
    outline: "none",
    border: "none",
  },
  add: {
    fontSize: "17px",
    marginLeft: "10px",
    fontWeight: "600",
    backgroundClip: "border-box",
    background: "-webkit-linear-gradient(#4a1d85, #156fbc)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
    cursor: "pointer",
    border: "none",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowY: "scroll",
    height: "150px",
    "&::-webkit-scrollbar": {
      width: "12px",
    },
  },
  links: {
    fontSize: "14px",
    display: "block",
    margin: "10px 0",
    outline: "none",
    border: "none",
    width: "100%",
    cursor: "pointer",
  },
  box: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  text: {
    color: "red",
    marginTop: "10px",
  },
  error: {
    color: "red",
    fontSize: "13px",
    marginTop: "10px",
    fontWeight: "600",
  },
  success: {
    color: "green",
    fontSize: "14px",
    marginTop: "10px",
    fontWeight: "600",
  },
  linkContainer: {
    display: "flex",
    // alignItems: "",
    width: "100%",
    justifyContent: "space-between",
    borderBottom: "1px solid #e6e6e6",
  },
  delbtn: {
    fontSize: "20px",
    color: "red",
    fontWeight: "600",
    border: "none",
    outline: "none",
    background: "transparent",
    cursor: "pointer",
  },
  title: {
    fontSize: "20px",
    fontWeight: "600",
    backgroundClip: "border-box",
    background: "-webkit-linear-gradient(#4a1d85, #156fbc)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
    border: "none",
  },
  button: {
    margin: "10px 0",
    width: "100%",
    borderRadius: "5px",
    padding: "10px",
    background: "linear-gradient(92.12deg, #4a1d85 1.79%, #156fbc 99.22%)",
    color: "white",
    cursor: "pointer",
    fontSize: "16px",
    border: "none",
    marginBottom: "10px",
  },
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  maxHeight: "fit-content",
  overflowY: "hidden",
  "-webkit-scrollbar": "none",
  bgcolor: "background.paper",
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
};
const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxHeight: "fit-content",
  overflowY: "hidden",
  "-webkit-scrollbar": "none",
  bgcolor: "background.paper",
  borderRadius: 4,
  boxShadow: 24,
  p: 4,
};
const width = window.innerWidth;
function AddVideoModal({ open, setOpen, list }) {
  const classes = useStyles();
  const [videoList, setVideoList] = React.useState([]);
  const [videoName, setVideoName] = React.useState("");
  const [error, setError] = React.useState("");
  const [detail, setDetail] = React.useState([]);

  console.log("list", list);

  const handleClose = () => {
    setOpen(false);
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (videoName === "") {
      return;
    }
    setVideoList([...videoList, videoName]);
    let YT_url =
      "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&id=";
    const key = "&key=AIzaSyDIcBfTRXG5W4G4QzzlkBDSN6W9Y3RXjQM";

    YT_url += videoName.slice(17);

    // YT_url += "%2C" + vids[i].slice(17);

    YT_url = (await YT_url) + key;
    const config = {
      method: "get",
      url: YT_url,
    };

    const result = await axios(config);

    let newResult = Object.assign(result?.data?.items[0], {
      videoName: videoName,
    });

    if (result.data.items.length !== 0) {
      await setDetail((prevArray) => [...prevArray, newResult]);
    }

    setVideoName("");
  };

  const checkLink = async (link) => {
    let check;
    if (videoList.includes(link)) {
      setError("Video already exists");
      setVideoName("");
    } else if (link !== "") {
      console.log("hello");
      check = await youtube_parser(link);
      if (check === false) {
        check = link;
        setError("Invalid link ");
        setVideoName("");
      }
    } else {
      setError("");
    }

    // return true;
    // setError("");
    setVideoName(check);
  };

  async function youtube_parser(url) {
    var regExp =
      /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = await url.match(regExp);
    return match && match[7].length === 11
      ? `https://youtu.be/${match[7]}`
      : false;
  }

  const removeVideo = (v) => {
    // e.preventDefault();

    const newList = videoList.filter((video) => video !== v);

    let newDetail = detail.filter((video) => video.videoName !== v);

    setDetail(newDetail);

    setVideoList(newList);
  };

  const handleUpload = () => {
    if (detail && detail.length > 0) {
      let videoDeatils = [];

      for (let i = 0; i < detail.length; i++) {
        let object = {
          videoName: detail[i].videoName,
          title: detail[i].snippet.title,
          description: detail[i].snippet.description,
          thumbnail: detail[i].snippet.thumbnails.high.url,
          publishedAt: detail[i].snippet.publishedAt,
          language: detail[i].snippet.defaultAudioLanguage,
        };
        videoDeatils.push(object);
      }
      console.log(videoDeatils, "videoDeatils");
      var config = {
        method: "post",
        url: `${API}/playlist/addvideo/${list._id}`,
        headers: {
          Authorization: `Bearer ${JSON.parse(
            localStorage.getItem("_access_token")
          )}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        data: { videos: videoDeatils },
      };

      axios(config)
        .then(function (response) {
          console.log(response, "response from add video");
          if (response.status === 200) {
            window.location.reload();
          } else {
            toast.error("Something went wrong");
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        className={classes.modal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={width > 768 ? style : style2}>
            <Typography
              variant="h6"
              id="transition-modal-title"
              className={classes.title}
            >
              Add Video Url's From Youtube
            </Typography>
            <Box className={classes.text}>
              {error && (
                <Typography
                  variant="h6"
                  id="transition-modal-title"
                  className={classes.error}
                >
                  * {error}
                </Typography>
              )}
              {videoList.length > 0 && (
                <Typography
                  variant="h6"
                  id="transition-modal-title"
                  className={classes.success}
                >
                  {videoList.length} videos added
                </Typography>
              )}
              {videoList.length === 0 ? (
                <Typography
                  variant="h6"
                  id="transition-modal-title"
                  className={classes.success}
                >
                  {videoList.length} videos added
                </Typography>
              ) : (
                <Box className={classes.list}>
                  {videoList.map((video, index) => (
                    <div className={classes.linkContainer}>
                      <input className={classes.links} value={video} readOnly />
                      <button
                        className={classes.delbtn}
                        onClick={() => removeVideo(video)}
                      >
                        x
                      </button>
                    </div>
                  ))}
                </Box>
              )}
            </Box>
            <Box className={classes.box}>
              <TextField
                id="outlined-basic"
                label=""
                placeholder="Add new URLs"
                value={videoName}
                onChange={(e) => checkLink(e.target.value)}
                className={classes.input}
              />
              <button
                className={classes.add}
                onClick={handleAdd}
                disabled={error}
              >
                Add
              </button>
            </Box>
            <button className={classes.button} onClick={handleUpload}>
              Upload
            </button>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default AddVideoModal;
